/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconColumns = createReactComponent("outline", "columns", "IconColumns", [["path", { "d": "M4 6l5.5 0", "key": "svg-0" }], ["path", { "d": "M4 10l5.5 0", "key": "svg-1" }], ["path", { "d": "M4 14l5.5 0", "key": "svg-2" }], ["path", { "d": "M4 18l5.5 0", "key": "svg-3" }], ["path", { "d": "M14.5 6l5.5 0", "key": "svg-4" }], ["path", { "d": "M14.5 10l5.5 0", "key": "svg-5" }], ["path", { "d": "M14.5 14l5.5 0", "key": "svg-6" }], ["path", { "d": "M14.5 18l5.5 0", "key": "svg-7" }]]);

export { IconColumns as default };
//# sourceMappingURL=IconColumns.mjs.map
